module.exports = __webpack_public_path__ + "components/closing-infographics/static/infographic__mobile--FR-0a8c766cdbdcb574b9c94676899f0bd2.jpg";